import { toast } from "sonner";

/** Turns a failed review request into the right nudge: sign in, top up, or a plain error. */
export const handleReviewError = (e, navigate, isGuest = false) => {
  const status = e.response?.status;
  const detail = e.response?.data?.detail;
  const msg = typeof detail === "string" ? detail : null;

  if (status === 401) {
    toast.error(msg || "Sign in to use this feature.");
    navigate("/login", { state: { from: window.location.pathname } });
    return;
  }
  if (status === 402) {
    toast.error(msg || "You are out of reviews.");
    navigate(isGuest ? "/login" : "/pricing", isGuest ? { state: { from: window.location.pathname } } : undefined);
    return;
  }
  toast.error(msg || "Something went wrong. Please try again.");
};
